"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

const ScrollToTop = ({
  location,
  children
}) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var _default = (0, _reactRouter.withRouter)(ScrollToTop);

exports.default = _default;
module.exports = exports.default;